// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../getISOWeeksInYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var getISOWeeksInYear = convertToFP(fn, 1);
export default getISOWeeksInYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/getISOWeeksInYear/index.js
// module id = 899
// module chunks = 0